export function findIdxByKeyValue(array, key, value) {
    for (let i = 0; i < array.length; i++) {
        if (array[i][key] == value) {
            return i;
        }
    }
    return null;
}

//通过js的内置对象JSON来进行数组对象的深拷贝
//Object.assign只能支持1级对象深拷贝，2级子对象以后均为浅拷贝
export function deepClone(obj) {
    let _obj = JSON.stringify(obj);
    let objClone = JSON.parse(_obj);
    return objClone;
}



// 图像压缩

import EXIF from 'exif-js'

// 获取图片信息
function getImageInfo(img, callback) {
    let Orientation = 1

    EXIF.getData(img, function () {
        Orientation = EXIF.getTag(this, 'Orientation');

        callback(Orientation)
    });
}

// 旋转画布
function rotate(ctx,Orientation){
    switch(Orientation){
        case 3:
            //旋转180度
            ctx.rotate(Math.PI)
            break;
        case 6:
            //旋转90度
            ctx.rotate(Math.PI/2)
            break;
        case 8:
            //旋转270度
            ctx.rotate(Math.PI*1.5)
            break;
    }
}

// canvas 绘制图片
function drawImage(img, quality, Orientation, callback) {
    const { width, height } = img
    //生成canvas
    var canvas = document.createElement("canvas");
    var ctx = canvas.getContext("2d");

    if(Orientation==3||Orientation==6){
        canvas.width = height
        canvas.height = width
    } else{
        canvas.width = width
        canvas.height = height
    }
    if(Orientation!=1){
        ctx.translate(canvas.width/2,canvas.width/2);
        rotate(ctx, Orientation)
        ctx.translate(-canvas.width/2,-canvas.width/2);
    }


    ctx.drawImage(img, 0, 0);
    // 图像质量
    if (!(quality && quality <= 1 && quality > 0)) {
        quality = 0.7
    }
    // quality值越小，所绘制出的图像越模糊
    canvas.toBlob(callback, "image/jpeg", quality);
}

// 图片渲染
function canvasDataURL(file, quality = 0.7, callback) {
    var img = new Image();
    img.src = window.URL.createObjectURL(file);

    img.onload = function () {
        getImageInfo(img, Orientation => {
            drawImage(img, quality, Orientation, callback)
        })
    };
}


export function  compressionImg(file, callback) {
    let newFile = null
    canvasDataURL(file, 0.4, blob => {
        // 处理后的file
        newFile = new File([blob], file.name, { type: blob.type })
        if (!newFile || newFile.size > file.size) {
            newFile = file
        }
        callback(newFile)
    });
}



export function getCookie(name)
{
    let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
    if(arr=document.cookie.match(reg))
        return unescape(arr[2]);
    else
        return null;
}

export function setCookie(value)
{
//    let Days = 30;
//    let exp = new Date();
//    exp.setTime(exp.getTime() + Days*24*60*60*1000);
    document.cookie = value;
//    document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
}

/**
 export function setCookie(name,value)
 {
//    let Days = 30;
//    let exp = new Date();
//    exp.setTime(exp.getTime() + Days*24*60*60*1000);
    document.cookie = name + "="+ escape (value) + ";";
//    document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
}*/

export function transformBase64ToBlob (base64) {
    let byteString

    if (base64.split(",")[0].indexOf("base64") >= 0) {
        byteString = atob(base64.split(",")[1])
    } else {
        byteString = unescape(base64.split(",")[1])
    }

    const mimeString = base64.split(",")[0].split(":")[1].split(";")[0]
    const ia = new Uint8Array(byteString.length)

    for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
    }

    const blob = new Blob([ia], {
        type: mimeString
    })

    return blob
}

export function curDateTimeFull() {
    let now = new Date(),
        y = now.getFullYear(),
        m = now.getMonth() + 1,
        d = now.getDate();
    return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
}


export function curDate() {
    let date = new Date();
    let y = date.getFullYear();
    let m = (date.getMonth()+1).toString().padStart(2,'0')
    let d = date.getDate().toString().padStart(2,'0')
    return y+m+d
}

export function curDateFull() {
    let now = new Date();
    let y = now.getFullYear();
    let m = now.getMonth() + 1;
    let d = now.getDate();
    console.log(y + '-' + m + '-' + d )
    return y + '-' + m + '-' + d // y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
}


export function nextCurDateFull() {
    let now = new Date();
    now.setMonth(now.getMonth() + 12); //加一年
    let y = now.getFullYear();
    let m = now.getMonth() + 1;
    let d = now.getDate();
    console.log(y + '-' + m + '-' + d )
    return y + '-' + m + '-' + d // y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
}

/**
 *
 var d = new Date('2021-12-17');
 d.setMonth(d.getMonth() + 6); //加半年
 d.setFullYear(d.getFullYear() + 1);  //加一年
 d.setMonth(d.getMonth() + 12); //加一年
 * */


export function getTimeStr(timeNum){
    let y,m,d,h,mm,s;
    let date = new Date(timeNum);
    y = date.getFullYear();
    m = date.getMonth()+1;
    d = date.getDate();
    h = date.getHours();
    mm = date.getMinutes();
    s = date.getSeconds();
    m = m < 10 ? "0" + m : m;
    d = d < 10 ? "0" + d : d;
    h = h < 10 ? "0" + h : h;
    mm = mm < 10 ? "0" + mm : mm;
    s = s < 10 ? "0" + s : s;
    let timeStr = y + "-" + m + "-" + d + " " + h + ":" + mm + ":" + s;
    return timeStr;
}

export function toPercent (point) {
    let str = Number(point*100).toFixed(0);
    str += "%";
    return str;
}

import SnowflakeId from "snowflake-id";

export const guid = num => {
    const snowflake = new SnowflakeId();
    let arr = [];
    for (let i = 0; i < num; i++) {
        arr.push(snowflake.generate());
    }
    return num ? arr : snowflake.generate();
};
